import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Could not retrieve data...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading4 = _resolveComponent("Heading4")!

  return (_openBlock(), _createBlock(_component_Heading4, { alignment: 'centered' }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}